export const GET_MENS_DATA_R = "GET_MENS_DATA_R";
export const GET_MENS_DATA_S = "GET_MENS_DATA_S";
export const GET_MENS_DATA_F = "GET_MENS_DATA_F";
export const GET_WOMENS_DATA_S = "GET_WOMENS_DATA_S";
export const GET_SHOES_DATA_S = "GET_SHOES_DATA_S";

export const GET_HOMEDATA_S = "GET_DATA_S";